module.exports = __webpack_public_path__ + "static/media/Lexikon.79efa40b.svg";